import { useNavigate } from "react-router-dom";
import { LogOut, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { eventPartnerLogout, getEventPartnerUser } from "@/services/eventPartnerService";

interface EventPartnerLayoutProps {
  children: React.ReactNode;
}

export const EventPartnerLayout = ({ children }: EventPartnerLayoutProps) => {
  const navigate = useNavigate();
  const user = getEventPartnerUser();

  const handleLogout = () => {
    eventPartnerLogout();
    navigate("/Event-Partner-Login");
  };

  return (
    <div className="min-h-screen bg-white text-gray-900">
      {/* Header */}
      <header className="border-b border-gray-800 bg-black">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="/Disco_Logo_v2_(480_x_150_px).png" 
              alt="Disco" 
              className="h-8"
            />
            <div className="h-6 w-px bg-gray-700" />
            <div className="flex items-center gap-2">
              <Calendar className="h-5 w-5 text-green-500" />
              <span className="font-medium text-white">Event Partner Portal</span>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {user && (
              <span className="text-sm text-gray-400">
                {user.username}
              </span>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="text-gray-400 hover:text-white hover:bg-gray-800"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Log out
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-6">
        {children}
      </main>
    </div>
  );
};
